import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from './MarketingLayout';
import { COLOR } from '../../components/ss/tokens';

export default function NotFound() {
  return (
    <MarketingLayout title="Page Not Found — Benevita">
      <div style={{
        minHeight: '60vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', flexDirection: 'column',
        textAlign: 'center', padding: '80px 24px',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>🏥</div>
        <h1 style={{ fontSize: 48, fontWeight: 800, color: COLOR.text, margin: '0 0 12px' }}>
          404
        </h1>
        <p style={{ fontSize: 20, color: COLOR.textMuted, marginBottom: 8 }}>
          Page not found
        </p>
        <p style={{ color: COLOR.textFaint, fontSize: 15, maxWidth: 360, lineHeight: 1.6, marginBottom: 40 }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/home" style={{
            background: COLOR.primary, color: '#fff',
            padding: '12px 28px', borderRadius: 8,
            fontWeight: 600, textDecoration: 'none', fontSize: 15,
          }}>
            Back to home
          </Link>
          <Link to="/contact" style={{
            background: '#fff', color: COLOR.primary,
            border: `2px solid ${COLOR.primary}`,
            padding: '12px 28px', borderRadius: 8,
            fontWeight: 600, textDecoration: 'none', fontSize: 15,
          }}>
            Contact us
          </Link>
        </div>
      </div>
    </MarketingLayout>
  );
}
